import React from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import EACheckbox from "../../shared/Checkbox/EACheckbox";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
}

const GdanskInstructorCheckboxInput: React.FC<IProps> = ({ form, setForm }) => {
  return (
    <div className="gdansk-input-content">
      <EACheckbox
        name="instructorRule"
        checked={form.intructorRule}
        onChange={(value) => setForm({ ...form, intructorRule: value })}
        label="Jestem instruktorem i na wynajętym torze będę prowadził naukę pływania i przyjmuję do wiadomości ze cena ulega zwiększeniu o bilet instruktorski w kwocie 30 PLN. Po zaznaczeniu checkboxa cena biletu zwiększa się o cenę biletu instruktorskiego. Po zakupie zachodzą następujące zależności"
      />
    </div>
  );
};

export default GdanskInstructorCheckboxInput;
